import React from 'react'
import { IoStar } from "react-icons/io5";

const style={ color: "#28A745", fontSize:"2rem",marginLeft:"20px",marginRight:"20px"}

const LookingFor = () => {
    return (
        <>
            <div className="maincontainer">
                {/* row */}
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title text-center style3 mb-4">
                            <div className="title-header mt-4">
                                <h2 className="looking-title">What You Looking for ? </h2>
                            </div>
                        </div>
                        <div className="looking-section mb-4">

                            <div className="ttm-iconbox-wrapper">

                                <h3 className='ttm-subheading'>You are a fundi</h3>

                                <div className="ttm-icon-layer">
                                    <img src={`assets/images/${"Layer-1"}.png`} alt="" />
                                </div>
                                <div className="header_btn">
                                    <a href={'/Contact_01'} className="ttm-btn">Get Started </a>
                                </div>
                                <div className="featured-desc">
                                    <p>advertise your skills!</p>
                                </div>

                            </div>
                            <div className="ttm-iconbox-wrapper">
                                <h3 className='ttm-subheading'>Find a fundi</h3>
                                <div className="ttm-icon-layer">
                                    <img src={`assets/images/${"Layer-2"}.png`} alt="" />
                                </div>
                                <div className="header_btn">
                                    <a href={'/Contact_01'} className="ttm-btn">Get Started </a>
                                </div>
                                <div className="featured-desc">
                                    <p>You are looking for a reliable Fundi?</p>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
                <div className="row">

                    <div className="col-lg-12 col-md-12">
                        <div className="service-content text-center mt-4">
                       

                            <h2 className='looking-title mt-2'>Home   <IoStar style = {style}/> Office <IoStar style={style} /> Apartment</h2>
                            <div className='mt-4'>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                            </div>

                        </div>

                    </div>
                </div>
                {/* row end */}
            </div>
        </>
    )
}

export default LookingFor;